module.exports = __webpack_public_path__ + "media/images/tutorialSlide__screenshot7-4036fb6964376bf459cb31620decc522.png";